module.exports = __webpack_public_path__ + "static/media/s-caro.e3c760fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s-caro.png
// module id = 2202
// module chunks = 0